import { SideDrawer, subLinkProps, LinkProps } from "../SideDrawer/SideDrawer";
import "./page.css";
interface PageProps {
  handleThemeChange?: (theme: string) => void;
  onClick?: (data: subLinkProps | LinkProps | any) => void;
  children: any;
  header?: any;
  sidenav: any;
  liquidStakingOptions: any;
  socials?: any;
  trackStaderLogoClick?: () => void;
  trackLiquidStakingClick: (key: string) => void;
  assetPrefix?: string;
}

export const Page = ({
  onClick,
  children,
  header,
  sidenav,
  liquidStakingOptions,
  socials,
  trackStaderLogoClick,
  trackLiquidStakingClick,
  assetPrefix = "",
}: PageProps) => {
  const handleClick = (data: subLinkProps | LinkProps) => {
    onClick && onClick(data);
  };

  return (
    <div className="container">
      <div>
        <SideDrawer
          assetPrefix={assetPrefix}
          onClick={handleClick}
          sidenav={sidenav}
          socials={socials}
          trackStaderLogoClick={trackStaderLogoClick}
          liquidStakingOptions={liquidStakingOptions}
          trackLiquidStakingClick={trackLiquidStakingClick}
        />
      </div>

      <div className={`wrapper brand.primary`}>
        {header}
        <div className="marginTop">{children}</div>
      </div>
    </div>
  );
};
